import React, { useState } from 'react';
import { X, Server } from 'lucide-react';
export const AddMCPServerModal = ({
  onClose,
  onAdd
}) => {
  const [serverName, setServerName] = useState('');
  const [serverUrl, setServerUrl] = useState('');
  const handleSubmit = e => {
    e.preventDefault();
    onAdd({
      name: serverName,
      url: serverUrl
    });
    onClose();
  };
  return <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50" data-id="element-283">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md" data-id="element-284">
        <div className="p-4 border-b border-gray-200 flex items-center justify-between" data-id="element-285">
          <div className="flex items-center" data-id="element-286">
            <Server className="w-5 h-5 text-gray-700 mr-2" data-id="element-287" />
            <h3 className="text-lg font-medium text-gray-800" data-id="element-288">
              Add MCP Server
            </h3>
          </div>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-289">
            <X className="w-5 h-5" data-id="element-290" />
          </button>
        </div>
        <form onSubmit={handleSubmit} data-id="element-291">
          <div className="p-4" data-id="element-292">
            <div className="mb-4" data-id="element-293">
              <label className="block text-sm text-gray-600 mb-1" data-id="element-294">
                Server Name
              </label>
              <input type="text" className="w-full p-2 border border-gray-200 rounded-md" value={serverName} onChange={e => setServerName(e.target.value)} required data-id="element-295" />
            </div>
            <div className="mb-4" data-id="element-296">
              <label className="block text-sm text-gray-600 mb-1" data-id="element-297">
                Server URL
              </label>
              <input type="url" className="w-full p-2 border border-gray-200 rounded-md" value={serverUrl} onChange={e => setServerUrl(e.target.value)} required data-id="element-298" />
            </div>
          </div>
          <div className="p-4 border-t border-gray-200 flex justify-end" data-id="element-299">
            <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-200 rounded-md mr-2 text-sm font-medium" data-id="element-300">
              Cancel
            </button>
            <button type="submit" className="px-4 py-2 bg-gray-800 text-white rounded-md text-sm font-medium" data-id="element-301">
              Add Server
            </button>
          </div>
        </form>
      </div>
    </div>;
};